/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Merge_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search by name or VEKN ID…" |
*
* @param {Vekn_Merge_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge_search_placeholder = /** @type {((inputs?: Vekn_Merge_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Merge_Search_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher par nom ou VEKN ID…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar por nombre o ID VEKN…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar por nome ou VEKN ID…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca per nome o VEKN ID…")
	return /** @type {LocalizedString} */ ("Search by name or VEKN ID…")
});